/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Top MCP server by tool call count
 */
export type TopServer = {
  /**
   * MCP server name
   */
  serverName: string;
  /**
   * Total number of tool calls
   */
  toolCallCount: number;
};

/** @internal */
export const TopServer$inboundSchema: z.ZodMiniType<TopServer, unknown> = z
  .pipe(
    z.object({
      server_name: z.string(),
      tool_call_count: z.int(),
    }),
    z.transform((v) => {
      return remap$(v, {
        "server_name": "serverName",
        "tool_call_count": "toolCallCount",
      });
    }),
  );

export function topServerFromJSON(
  jsonString: string,
): SafeParseResult<TopServer, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => TopServer$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'TopServer' from JSON`,
  );
}
